<template>
    <div>
        <indexJP v-if="checkGeneralEnvironment() == 3"/>
        <indexVN v-else/>
    </div>
</template>

<script>
import indexJP from '@/views/index/index_jp';
import indexVN from '@/views/index/index_vn';

export default {
    components: {
        indexJP,
        indexVN,
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/index/index.vue